/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  listMemberships,
  getUsers,
  updatePlan,
  updateUser,
  listEvents,
  getUserDetails,
  deleteBeneficiary,
} from '../services/api_service';
import {
  Container,
  Paper,
  IconButton,
  InputBase,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Card,
  CardContent,
  Box,
  Chip,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Drawer,
  Avatar,
  Skeleton,
  Tooltip,
  Tabs,
  Tab,
  Stack,
  Fade,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useAlert } from '../AlertContext';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RefreshIcon from '@mui/icons-material/Refresh';

function formatScheduleDate(date) {
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return 'Fecha no disponible';
  }
  return new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(d);
}

function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [membership, setMembership] = useState([]);
  const [detailsId, setDetailsId] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [membershipFilter, setMembershipFilter] = useState('all');
  const [sortBy, setSortBy] = useState('name');
  // eslint-disable-next-line no-unused-vars
  const [sortOrder, setSortOrder] = useState('asc');
  const [events, setEvents] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState({});
  const [loading, setLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [tabValue, setTabValue] = useState(0);
  const { showAlert } = useAlert();

  // Pagination state
  const [page, setPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // New state for editing and viewing appointments
  const [editingBeneficiary, setEditingBeneficiary] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [viewingAppointments, setViewingAppointments] = useState(null);
  const [beneficiaryAppointments, setBeneficiaryAppointments] = useState([]);
  const [confirmMembership, setConfirmMembership] = useState(null);

  useEffect(() => {
    listMemberships()
      .then((response) => {
        if (response && response.result) {
          setMembership(response.result);
        }
      })
      .catch(() => {
        showAlert('Tuvimos un error procesando esta acción', 'error');
      });
  }, []);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setPage(1); // Reset to page 1 on new search
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    getData();
  }, [page, limit, debouncedSearch, membershipFilter]);

  const fetchEvents = () => {
    listEvents()
      .then((response) => {
        if (response) {
          setEvents(response);
        }
      })
      .catch(() => {
        showAlert('Tuvimos un error procesando esta acción', 'error');
      });
  };

  const getData = () => {
    setLoading(true);
    getUsers({
      page,
      limit,
      search: debouncedSearch,
      membership_id: membershipFilter,
    })
      .then((response) => {
        if (response && response.result) {
          setUsers(response.result);
          setTotalCount(response.totalCount || 0);
          fetchEvents();
        }
      })
      .catch(() => {
        showAlert('Tuvimos un error procesando esta acción', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchUserDetails = async (userId) => {
    setDetailsLoading(true);
    try {
      const response = await getUserDetails(userId);
      if (response) {
        setUserDetails((prev) => ({ ...prev, [userId]: response }));
        if (response.beneficiaries) {
          setBeneficiaries((prev) => ({
            ...prev,
            [userId]: response.beneficiaries,
          }));
        }
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      showAlert('Error al cargar detalles del usuario', 'error');
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleExpandClick = (user) => {
    if (detailsId === user.users_id) {
      setDetailsId(null);
    } else {
      setDetailsId(user.users_id);
      setTabValue(0);
      fetchUserDetails(user.users_id);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const update = (email_notifications, whatsapp_notifications) => {
    const user = users.find((u) => u.users_id === detailsId);
    user.send_notifications_email = email_notifications;
    user.send_notifications_whatsapp = whatsapp_notifications;
    updateUser(user.users_id, user)
      .then((response) => {
        if (response) {
          getData();
          showAlert('Configuración actualizada!', 'success');
        }
      })
      .catch(() => {
        showAlert('Tuvimos un error procesando esta acción', 'error');
      });
  };

  const handleUpdateBeneficiary = () => {
    updateUser(editingBeneficiary.id, editingBeneficiary)
      .then((response) => {
        if (response) {
          fetchUserDetails(detailsId);
          setEditingBeneficiary(null);
          showAlert('Beneficiario actualizado!', 'success');
        }
      })
      .catch(() => {
        showAlert('Error al actualizar el beneficiario', 'error');
      });
  };

  const handleUpdateUser = () => {
    updateMembership(
      editingUser.users_id,
      editingUser.membership_id,
      editingUser.serial
    );
    updateUser(editingUser.users_id, editingUser)
      .then((response) => {
        if (response) {
          getData();
          setEditingUser(null);
          showAlert('Usuario actualizado!', 'success');
        }
      })
      .catch(() => {
        showAlert('Error al actualizar el usuario', 'error');
      });
  };

  const handleOpenAppointments = (beneficiary) => {
    const apps =
      events?.result?.filter((e) =>
        e.description.includes(`CC: ${beneficiary.identification_number}`)
      ) || [];
    setBeneficiaryAppointments(apps);
    setViewingAppointments(beneficiary);
  };

  const updateMembership = (
    users_id,
    membership_id,
    serial = undefined,
    keepSerial = true,
    keepBeneficiaries = true
  ) => {
    updatePlan(users_id, {
      membership_id,
      serial,
      keepSerial,
      keepBeneficiaries,
    })
      .then((response) => {
        if (response) {
          getData();
          // Update details if drawer is open
          if (detailsId === users_id) {
            fetchUserDetails(users_id);
          }
          showAlert('Configuración actualizada!', 'success');
          setConfirmMembership(null);
        }
      })
      .catch(() => {
        showAlert('Tuvimos un error procesando esta acción', 'error');
      });
  };

  const handleDeleteBeneficiary = (beneficiaryId) => {
    if (
      window.confirm(
        '¿Estás seguro de que deseas eliminar a este beneficiario? Se le asignará un plan NO AFILIADO.'
      )
    ) {
      deleteBeneficiary(beneficiaryId)
        .then(() => {
          showAlert('Beneficiario eliminado correctamente', 'success');
          fetchUserDetails(detailsId);
          getData();
        })
        .catch(() => {
          showAlert('Error al eliminar el beneficiario', 'error');
        });
    }
  };

  const filteredUsers = users.sort((a, b) => {
    let comparison = 0;
    if (sortBy === 'name') {
      comparison = (a.name || '').localeCompare(b.name || '');
    } else if (sortBy === 'create_at') {
      const dateA = a.create_at ? new Date(a.create_at) : new Date(0);
      const dateB = b.create_at ? new Date(b.create_at) : new Date(0);
      comparison = dateA - dateB;
    } else if (sortBy === 'ends_at') {
      const dateA = a.ends_at ? new Date(a.ends_at) : new Date(0);
      const dateB = b.ends_at ? new Date(b.ends_at) : new Date(0);
      comparison = dateA - dateB;
    }
    return sortOrder === 'asc' ? comparison : -comparison;
  });

  const getMembershipColor = (membershipDescription) => {
    switch (membershipDescription?.toUpperCase()) {
      case 'NO AFILIADO':
        return 'error';
      case 'BÁSICO':
        return 'warning';
      case 'PREMIUM':
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Fade in={true} timeout={800}>
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h3"
            fontWeight="800"
            gutterBottom
            sx={{ color: '#000', letterSpacing: '-0.5px' }}
          >
            Panel de Usuarios
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontSize: '1.1rem' }}
          >
            Gestiona la base de datos de usuarios, sus planes y beneficios.
          </Typography>
        </Box>
      </Fade>

      <Card
        sx={{
          mb: 4,
          borderRadius: 3,
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={5}>
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: 2,
                  bgcolor: '#f8f9fa',
                  px: 2,
                  py: 0.5,
                  border: '1px solid #e0e0e0',
                }}
              >
                <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />
                <InputBase
                  sx={{ flex: 1, py: 1 }}
                  placeholder="Buscar por nombre o cédula"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <IconButton size="small" onClick={() => setSearchTerm('')}>
                    <RefreshIcon sx={{ fontSize: '1rem' }} />
                  </IconButton>
                )}
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4} md={2.5}>
              <FormControl fullWidth size="small">
                <InputLabel>Plan de Afiliación</InputLabel>
                <Select
                  value={membershipFilter}
                  label="Plan de Afiliación"
                  onChange={(e) => {
                    setMembershipFilter(e.target.value);
                    setPage(1);
                  }}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="all">Todos los planes</MenuItem>
                  {membership.map((m) => (
                    <MenuItem key={m.id} value={m.id}>
                      {m.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={2.5}>
              <FormControl fullWidth size="small">
                <InputLabel>Ordenar por</InputLabel>
                <Select
                  value={sortBy}
                  label="Ordenar por"
                  onChange={(e) => setSortBy(e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="name">Nombre</MenuItem>
                  <MenuItem value="create_at">Fecha de ingreso</MenuItem>
                  <MenuItem value="ends_at">Fecha de vencimiento</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<RefreshIcon />}
                onClick={getData}
                sx={{ height: 40, borderRadius: 2 }}
              >
                Refrescar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 3,
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          overflow: 'hidden',
        }}
      >
        <Table
          sx={{ minWidth: 650 }}
          stickyHeader
          aria-label="modern users table"
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: '700', bgcolor: '#f8f9fa' }}>
                Usuario
              </TableCell>
              <TableCell sx={{ fontWeight: '700', bgcolor: '#f8f9fa' }}>
                Identificación
              </TableCell>
              <TableCell sx={{ fontWeight: '700', bgcolor: '#f8f9fa' }}>
                Contacto
              </TableCell>
              <TableCell sx={{ fontWeight: '700', bgcolor: '#f8f9fa' }}>
                Afiliación
              </TableCell>
              <TableCell sx={{ fontWeight: '700', bgcolor: '#f8f9fa' }}>
                Vigencia
              </TableCell>
              <TableCell
                sx={{ fontWeight: '700', bgcolor: '#f8f9fa' }}
                align="center"
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(limit)].map((_, i) => (
                <TableRow key={i}>
                  {[...Array(6)].map((_, j) => (
                    <TableCell key={j}>
                      <Skeleton variant="text" height={32} />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : users.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 10 }}>
                  <Box sx={{ opacity: 0.5 }}>
                    <PersonIcon sx={{ fontSize: 60, mb: 2 }} />
                    <Typography variant="h6">
                      No se encontraron resultados
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              filteredUsers.map((user) => (
                <TableRow
                  key={user.users_id}
                  hover
                  onClick={() => handleExpandClick(user)}
                  sx={{
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)' },
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Box>
                        <Typography variant="body1" fontWeight="700">
                          {user.name}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body1">
                      {user.identification_type} {user.identification_number}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Stack spacing={0.5}>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        <MailOutlineIcon
                          sx={{ fontSize: 18, color: 'text.secondary' }}
                        />
                        <Typography variant="body1">
                          {user.email?.toLowerCase()}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        <WhatsAppIcon sx={{ fontSize: 18, color: '#25D366' }} />
                        <Typography variant="body1">{user.phone}</Typography>
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack spacing={1}>
                      <Chip
                        label={user.membership_description || 'Sin plan'}
                        color={getMembershipColor(user.membership_description)}
                        sx={{ fontWeight: 'bold', width: 'fit-content' }}
                      />
                      <Box
                        sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
                      >
                        <Chip
                          label={user.role || 'Titular'}
                          variant="outlined"
                          sx={{ width: 'fit-content' }}
                        />
                        {user.last_valid_serial && (
                          <Typography variant="caption" color="text.secondary">
                            Serial: <strong>{user.last_valid_serial}</strong>
                          </Typography>
                        )}
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Typography variant="body1" fontWeight="bold">
                        {user.create_at && user.ends_at
                          ? `${new Date(user.create_at).toLocaleDateString('es-ES')} - ${new Date(user.ends_at).toLocaleDateString('es-ES')}`
                          : 'N/A'}
                      </Typography>
                      {user.ends_at && (
                        <Typography
                          variant="body1"
                          color={
                            Math.ceil(
                              (new Date(user.ends_at) - new Date()) /
                                (1000 * 60 * 60 * 24)
                            ) < 30
                              ? 'error.main'
                              : 'text.secondary'
                          }
                        >
                          {Math.max(
                            0,
                            Math.ceil(
                              (new Date(user.ends_at) - new Date()) /
                                (1000 * 60 * 60 * 24)
                            )
                          )}{' '}
                          días restantes
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Editar perfil">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingUser({ ...user });
                        }}
                        sx={{ color: 'primary.main' }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 4,
          px: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Mostrando {users.length} de {totalCount} registros
        </Typography>
        <Pagination
          count={Math.ceil(totalCount / limit)}
          page={page}
          onChange={(e, v) => setPage(v)}
          color="primary"
          shape="rounded"
          size="large"
        />
      </Box>

      {/* Modern Right Drawer */}
      <Drawer
        anchor="right"
        open={Boolean(detailsId)}
        onClose={() => setDetailsId(null)}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 550, md: 650 },
            borderLeft: 'none',
            boxShadow: '-10px 0 30px rgba(0,0,0,0.1)',
          },
        }}
      >
        {detailsId && (
          <Box
            sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
          >
            {/* Drawer Header */}
            <Box
              sx={{
                p: 4,
                bgcolor: 'primary.main',
                color: 'white',
                position: 'relative',
              }}
            >
              <IconButton
                onClick={() => setDetailsId(null)}
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  color: 'white',
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                }}
              >
                <ExpandMoreIcon sx={{ transform: 'rotate(-90deg)' }} />
              </IconButton>

              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 3, mt: 2 }}
              >
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: 'white',
                    color: 'primary.main',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                  }}
                >
                  {users.find((u) => u.users_id === detailsId)?.name?.charAt(0)}
                </Avatar>
                <Box>
                  <Typography variant="h5" fontWeight="800" sx={{ mb: 0.5 }}>
                    {users.find((u) => u.users_id === detailsId)?.name}
                  </Typography>
                  {users.find((u) => u.users_id === detailsId)?.role ===
                    'Beneficiario' &&
                    userDetails[detailsId]?.planHistory?.find((p) => p.active)
                      ?.owner_name && (
                      <Typography
                        variant="body1"
                        sx={{ mb: 1, fontStyle: 'italic', opacity: 0.9 }}
                      >
                        Beneficiario de:{' '}
                        {
                          userDetails[detailsId].planHistory.find(
                            (p) => p.active
                          ).owner_name
                        }
                      </Typography>
                    )}
                  <Stack direction="row" spacing={1}>
                    <Chip
                      label={`ID: ${users.find((u) => u.users_id === detailsId)?.identification_number}`}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        color: 'white',
                        border: 'none',
                      }}
                    />
                    <Chip
                      label={
                        users.find((u) => u.users_id === detailsId)?.role ||
                        'Titular'
                      }
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        color: 'white',
                        border: 'none',
                      }}
                    />
                  </Stack>
                </Box>
              </Box>
            </Box>

            {/* Tabs Navigation */}
            <Box
              sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: '#fff' }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="fullWidth"
                textColor="primary"
                indicatorColor="primary"
                sx={{ '& .MuiTab-root': { py: 2, fontWeight: 'bold' } }}
              >
                <Tab
                  label="General"
                  icon={<PersonIcon />}
                  iconPosition="start"
                />
                <Tab
                  label="Citas"
                  icon={<CalendarMonthIcon />}
                  iconPosition="start"
                />
                <Tab
                  label="Beneficiarios"
                  icon={<PersonIcon />}
                  iconPosition="start"
                />
                <Tab
                  label="Historial"
                  icon={<AccessTimeIcon />}
                  iconPosition="start"
                />
              </Tabs>
            </Box>

            {/* Drawer Content */}
            <Box
              sx={{ flexGrow: 1, overflowY: 'auto', bgcolor: '#fbfbfb', p: 4 }}
            >
              {detailsLoading ? (
                <Stack spacing={3}>
                  <Skeleton
                    variant="rectangular"
                    height={150}
                    sx={{ borderRadius: 2 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={150}
                    sx={{ borderRadius: 2 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={150}
                    sx={{ borderRadius: 2 }}
                  />
                </Stack>
              ) : (
                <>
                  <TabPanel value={tabValue} index={0}>
                    <Stack spacing={4}>
                      <Box>
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          fontWeight="bold"
                          gutterBottom
                        >
                          NOTIFICACIONES
                        </Typography>
                        <Card variant="outlined" sx={{ borderRadius: 2 }}>
                          <CardContent>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      users.find(
                                        (u) => u.users_id === detailsId
                                      )?.send_notifications_whatsapp
                                    }
                                    onChange={() =>
                                      update(
                                        users.find(
                                          (u) => u.users_id === detailsId
                                        )?.send_notifications_email,
                                        !users.find(
                                          (u) => u.users_id === detailsId
                                        )?.send_notifications_whatsapp
                                      )
                                    }
                                  />
                                }
                                label={
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <WhatsAppIcon sx={{ color: '#25D366' }} />
                                    <Typography variant="body1">
                                      Notificaciones WhatsApp
                                    </Typography>
                                  </Stack>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      users.find(
                                        (u) => u.users_id === detailsId
                                      )?.send_notifications_email
                                    }
                                    onChange={() =>
                                      update(
                                        !users.find(
                                          (u) => u.users_id === detailsId
                                        )?.send_notifications_email,
                                        users.find(
                                          (u) => u.users_id === detailsId
                                        )?.send_notifications_whatsapp
                                      )
                                    }
                                  />
                                }
                                label={
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <MailOutlineIcon
                                      sx={{ color: '#1976d2' }}
                                    />
                                    <Typography variant="body1">
                                      Notificaciones Email
                                    </Typography>
                                  </Stack>
                                }
                              />
                            </FormGroup>
                          </CardContent>
                        </Card>
                      </Box>

                      <Box>
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          fontWeight="bold"
                          gutterBottom
                        >
                          GESTIÓN DE PLAN
                        </Typography>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            borderLeft: '4px solid',
                            borderLeftColor: 'primary.main',
                          }}
                        >
                          <CardContent>
                            {users.find((u) => u.users_id === detailsId)
                              ?.role === 'Beneficiario' && (
                              <Box
                                sx={{
                                  mb: 2,
                                  p: 2,
                                  bgcolor: '#fff3e0',
                                  borderRadius: 1,
                                  border: '1px solid #ffe0b2',
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  color="warning.main"
                                  fontWeight="bold"
                                >
                                  Este usuario es actualmente un BENEFICIARIO.
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Al seleccionar un nuevo plan, dejará de ser
                                  beneficiario y se convertirá en TITULAR de su
                                  propio plan.
                                </Typography>
                              </Box>
                            )}
                            <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                              <InputLabel>Actualizar Plan</InputLabel>
                              <Select
                                value={
                                  users.find((u) => u.users_id === detailsId)
                                    ?.role === 'Beneficiario'
                                    ? ''
                                    : users.find(
                                        (u) => u.users_id === detailsId
                                      )?.membership_id || ''
                                }
                                label="Actualizar Plan"
                                onChange={(e) => {
                                  const selectedUser = users.find(
                                    (u) => u.users_id === detailsId
                                  );
                                  setConfirmMembership({
                                    users_id: detailsId,
                                    membership_id: e.target.value,
                                    membership_name: membership.find(
                                      (m) => m.id === e.target.value
                                    )?.description,
                                    user_name: selectedUser?.name,
                                    serial: selectedUser?.last_valid_serial,
                                    keepSerial: true,
                                    keepBeneficiaries: true,
                                  });
                                }}
                              >
                                {membership.map((m) => (
                                  <MenuItem key={m.id} value={m.id}>
                                    {m.description} — ${m.price || 0}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Inició el:
                                </Typography>
                                <Typography variant="body2" fontWeight="bold">
                                  {users.find((u) => u.users_id === detailsId)
                                    ?.create_at
                                    ? new Date(
                                        users.find(
                                          (u) => u.users_id === detailsId
                                        ).create_at
                                      ).toLocaleDateString('es-ES')
                                    : '—'}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Vence el:
                                </Typography>
                                <Typography variant="body2" fontWeight="bold">
                                  {users.find((u) => u.users_id === detailsId)
                                    ?.ends_at
                                    ? new Date(
                                        users.find(
                                          (u) => u.users_id === detailsId
                                        ).ends_at
                                      ).toLocaleDateString('es-ES')
                                    : '—'}
                                </Typography>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Box>
                    </Stack>
                  </TabPanel>

                  <TabPanel value={tabValue} index={1}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mb: 2 }}
                    >
                      PRÓXIMAS CITAS PROGRAMADAS
                    </Typography>
                    {userDetails[detailsId]?.appointments?.length > 0 ? (
                      <Stack spacing={2}>
                        {userDetails[detailsId].appointments.map((app, i) => (
                          <Card
                            key={i}
                            variant="outlined"
                            sx={{
                              borderRadius: 2,
                              '&:hover': {
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                              },
                            }}
                          >
                            <CardContent sx={{ py: 2 }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                }}
                              >
                                <Avatar
                                  sx={{
                                    bgcolor: 'rgba(25, 118, 210, 0.1)',
                                    color: 'primary.main',
                                  }}
                                >
                                  <EventIcon />
                                </Avatar>
                                <Box sx={{ flexGrow: 1 }}>
                                  <Typography variant="body2" fontWeight="bold">
                                    {formatScheduleDate(new Date(app.start))}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Dr. {app.doctor || 'Por asignar'}
                                  </Typography>
                                </Box>
                                <Chip
                                  label="Pendiente"
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                />
                              </Box>
                            </CardContent>
                          </Card>
                        ))}
                      </Stack>
                    ) : (
                      <Box sx={{ textAlign: 'center', py: 8, opacity: 0.6 }}>
                        <CalendarMonthIcon sx={{ fontSize: 48, mb: 1 }} />
                        <Typography variant="body2">
                          No hay citas registradas en el sistema.
                        </Typography>
                      </Box>
                    )}
                  </TabPanel>

                  <TabPanel value={tabValue} index={2}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mb: 2 }}
                    >
                      BENEFICIARIOS
                    </Typography>
                    {beneficiaries[detailsId]?.length > 0 ? (
                      <Grid container spacing={2}>
                        {beneficiaries[detailsId].map((ben, i) => (
                          <Grid item xs={12} key={i}>
                            <Card variant="outlined" sx={{ borderRadius: 2 }}>
                              <CardContent sx={{ p: 2 }}>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 2,
                                    }}
                                  >
                                    <Avatar
                                      sx={{
                                        bgcolor: 'secondary.light',
                                        width: 40,
                                        height: 40,
                                      }}
                                    >
                                      {ben.name?.charAt(0)}
                                    </Avatar>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                      >
                                        {ben.name}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        display="block"
                                      >
                                        {ben.identification_type}{' '}
                                        {ben.identification_number}
                                      </Typography>
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{ mt: 0.5 }}
                                      >
                                        {ben.phone && (
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 0.5,
                                            }}
                                          >
                                            <WhatsAppIcon
                                              sx={{
                                                fontSize: 14,
                                                color: '#25D366',
                                              }}
                                            />
                                            <Typography
                                              variant="body2"
                                              color="text.secondary"
                                            >
                                              {ben.phone}
                                            </Typography>
                                          </Box>
                                        )}
                                        {ben.email && (
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 0.5,
                                            }}
                                          >
                                            <MailOutlineIcon
                                              sx={{
                                                fontSize: 14,
                                                color: '#1976d2',
                                              }}
                                            />
                                            <Typography
                                              variant="body2"
                                              color="text.secondary"
                                            >
                                              {ben.email.toLowerCase()}
                                            </Typography>
                                          </Box>
                                        )}
                                      </Stack>
                                    </Box>
                                  </Box>
                                  <Box>
                                    <Tooltip title="Ver Citas">
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          handleOpenAppointments(ben)
                                        }
                                      >
                                        <CalendarMonthIcon
                                          fontSize="small"
                                          color="primary"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Editar">
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          setEditingBeneficiary({ ...ben })
                                        }
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Eliminar">
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          handleDeleteBeneficiary(ben.id)
                                        }
                                        sx={{ color: 'error.main' }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </Box>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Box sx={{ textAlign: 'center', py: 8, opacity: 0.6 }}>
                        <PersonIcon sx={{ fontSize: 48, mb: 1 }} />
                        <Typography variant="body2">
                          No tiene beneficiarios registrados.
                        </Typography>
                      </Box>
                    )}
                  </TabPanel>

                  <TabPanel value={tabValue} index={3}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mb: 2 }}
                    >
                      HISTORIAL DE AFILIACIONES
                    </Typography>
                    <TableContainer
                      component={Paper}
                      variant="outlined"
                      sx={{ borderRadius: 2 }}
                    >
                      <Table size="small">
                        <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', py: 1.5 }}>
                              Plan
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Serial
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Periodo
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 'bold' }}
                              align="center"
                            >
                              Estado
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {userDetails[detailsId]?.planHistory?.map((h, i) => (
                            <TableRow key={i}>
                              <TableCell sx={{ py: 1.5 }}>
                                <Typography variant="caption" fontWeight="bold">
                                  {h.membership_description}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  color="text.secondary"
                                >
                                  {h.role}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="caption">
                                  {h.serial || '—'}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="caption">
                                  {new Date(h.create_at).toLocaleDateString(
                                    'es-ES'
                                  )}{' '}
                                  —{' '}
                                  {new Date(h.ends_at).toLocaleDateString(
                                    'es-ES'
                                  )}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Chip
                                  label={h.active ? 'Activo' : 'Vencido'}
                                  size="small"
                                  color={h.active ? 'success' : 'default'}
                                  variant="outlined"
                                  sx={{ height: 20, fontSize: '0.65rem' }}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                </>
              )}
            </Box>
          </Box>
        )}
      </Drawer>

      {/* Dialogs remain unchanged in functionality */}
      <Dialog
        open={Boolean(editingBeneficiary)}
        onClose={() => setEditingBeneficiary(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Editar Beneficiario</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              label="Nombre Completo"
              fullWidth
              value={editingBeneficiary?.name || ''}
              onChange={(e) =>
                setEditingBeneficiary({
                  ...editingBeneficiary,
                  name: e.target.value,
                })
              }
            />

            <FormControl fullWidth>
              <InputLabel>Tipo ID</InputLabel>
              <Select
                value={editingBeneficiary?.identification_type || ''}
                label="Tipo ID"
                onChange={(e) =>
                  setEditingBeneficiary({
                    ...editingBeneficiary,
                    identification_type: e.target.value,
                  })
                }
              >
                <MenuItem value="CC">CC</MenuItem>
                <MenuItem value="TI">TI</MenuItem>
                <MenuItem value="CE">CE</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Número ID"
              fullWidth
              value={editingBeneficiary?.identification_number || ''}
              onChange={(e) =>
                setEditingBeneficiary({
                  ...editingBeneficiary,
                  identification_number: e.target.value,
                })
              }
            />

            <TextField
              label="Correo"
              fullWidth
              value={editingBeneficiary?.email || ''}
              onChange={(e) =>
                setEditingBeneficiary({
                  ...editingBeneficiary,
                  email: e.target.value,
                })
              }
            />
            <TextField
              label="Teléfono"
              fullWidth
              value={editingBeneficiary?.phone || ''}
              onChange={(e) =>
                setEditingBeneficiary({
                  ...editingBeneficiary,
                  phone: e.target.value,
                })
              }
            />
            <TextField
              label="Dirección"
              fullWidth
              value={editingBeneficiary?.address || ''}
              onChange={(e) =>
                setEditingBeneficiary({
                  ...editingBeneficiary,
                  address: e.target.value,
                })
              }
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditingBeneficiary(null)}>Cancelar</Button>
          <Button onClick={handleUpdateBeneficiary} variant="contained">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(editingUser)}
        onClose={() => setEditingUser(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Editar Usuario</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              label="Nombre Completo"
              fullWidth
              value={editingUser?.name || ''}
              onChange={(e) =>
                setEditingUser({ ...editingUser, name: e.target.value })
              }
            />

            <FormControl fullWidth>
              <InputLabel>Tipo ID</InputLabel>
              <Select
                value={editingUser?.identification_type || ''}
                label="Tipo ID"
                onChange={(e) =>
                  setEditingUser({
                    ...editingUser,
                    identification_type: e.target.value,
                  })
                }
              >
                <MenuItem value="CC">CC</MenuItem>
                <MenuItem value="TI">TI</MenuItem>
                <MenuItem value="CE">CE</MenuItem>
                <MenuItem value="PP">PP</MenuItem>
                <MenuItem value="DNI">DNI</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Número ID"
              fullWidth
              value={editingUser?.identification_number || ''}
              onChange={(e) =>
                setEditingUser({
                  ...editingUser,
                  identification_number: e.target.value,
                })
              }
            />

            <TextField
              label="Correo"
              fullWidth
              value={editingUser?.email || ''}
              onChange={(e) =>
                setEditingUser({ ...editingUser, email: e.target.value })
              }
            />
            <TextField
              label="Teléfono"
              fullWidth
              value={editingUser?.phone || ''}
              onChange={(e) =>
                setEditingUser({ ...editingUser, phone: e.target.value })
              }
            />
            <TextField
              label="Dirección"
              fullWidth
              value={editingUser?.address || ''}
              onChange={(e) =>
                setEditingUser({ ...editingUser, address: e.target.value })
              }
            />
            <TextField
              label="Serial"
              fullWidth
              value={editingUser?.serial || ''}
              onChange={(e) =>
                setEditingUser({ ...editingUser, serial: e.target.value })
              }
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditingUser(null)}>Cancelar</Button>
          <Button onClick={handleUpdateUser} variant="contained">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(confirmMembership)}
        onClose={() => setConfirmMembership(null)}
      >
        <DialogTitle>Confirmar Cambio de Plan</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ¿Cambiar plan de <strong>{confirmMembership?.user_name}</strong> a{' '}
            <strong>{confirmMembership?.membership_name}</strong>?
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={confirmMembership?.keepSerial || false}
                  onChange={(e) =>
                    setConfirmMembership({
                      ...confirmMembership,
                      keepSerial: e.target.checked,
                    })
                  }
                />
              }
              label={
                confirmMembership?.serial
                  ? `Mantener Serial actual (${confirmMembership.serial})`
                  : 'Mantener Serial actual'
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={confirmMembership?.keepBeneficiaries || false}
                  onChange={(e) =>
                    setConfirmMembership({
                      ...confirmMembership,
                      keepBeneficiaries: e.target.checked,
                    })
                  }
                />
              }
              label="Mantener Beneficiarios actuales"
            />
          </FormGroup>
          {confirmMembership?.keepBeneficiaries &&
            (
              beneficiaries[confirmMembership?.users_id] ||
              userDetails[confirmMembership?.users_id]?.beneficiaries
            )?.length > 0 && (
              <Box sx={{ mt: 2, p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                <Typography
                  variant="caption"
                  fontWeight="bold"
                  display="block"
                  gutterBottom
                >
                  Beneficiarios a copiar:
                </Typography>
                <Stack spacing={1}>
                  {(
                    beneficiaries[confirmMembership.users_id] ||
                    userDetails[confirmMembership.users_id].beneficiaries
                  ).map((ben, i) => (
                    <Box
                      key={i}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Typography variant="caption">{ben.name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {ben.identification_type} {ben.identification_number}
                      </Typography>
                    </Box>
                  ))}{' '}
                </Stack>
              </Box>
            )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmMembership(null)}>Cancelar</Button>
          <Button
            onClick={() =>
              updateMembership(
                confirmMembership.users_id,
                confirmMembership.membership_id,
                undefined,
                confirmMembership.keepSerial,
                confirmMembership.keepBeneficiaries
              )
            }
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(viewingAppointments)}
        onClose={() => setViewingAppointments(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EventIcon color="primary" /> Citas de {viewingAppointments?.name}
        </DialogTitle>
        <DialogContent dividers>
          {beneficiaryAppointments.length > 0 ? (
            <Stack spacing={2}>
              {beneficiaryAppointments.map((app, i) => (
                <Card key={i} variant="outlined">
                  <CardContent>
                    <Typography variant="body2" fontWeight="bold">
                      {formatScheduleDate(new Date(app.start))}
                    </Typography>
                    <Typography variant="caption">
                      {app.doctor || 'Cita médica'}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Stack>
          ) : (
            <Typography variant="body2" align="center" sx={{ py: 4 }}>
              Sin citas programadas.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setViewingAppointments(null)}
            variant="contained"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
